import { render } from "./EventCalendar.vue?vue&type=template&id=6b2b5d11"
import script from "./EventCalendar.vue?vue&type=script&lang=js"
export * from "./EventCalendar.vue?vue&type=script&lang=js"

import "./EventCalendar.vue?vue&type=style&index=0&id=6b2b5d11&lang=css"
script.render = render

export default script